import React, { useState, useEffect } from "react";
import { Card, CardContent, CardActions, Button, Typography, Container } from '@mui/material';
import { useParams } from 'react-router-dom';
import { providerNameApi } from "../../../../api/providerApi/providerApi";
import useEncryption from "../../../../services/useEncryption";
import logoMain from "../../../../assets/images/mainlogo.svg";
import "../signupforms.css";

const WelcomeProvider = ({ setShowGreeting }) => {
    const [organizationName, setOrganizationName] = useState('');
    const { encryptData, decryptData } = useEncryption();
    const { providerId } = useParams();

  const handleStartSignup = () => {
    setShowGreeting(false);
  };

  useEffect(() => {
    const providerName= async () => {
      try {
        const response = await providerNameApi(providerId);
        const decryptedData = decryptData(response?.data?.data);
        if (decryptedData && decryptedData.organizationName) {
            setOrganizationName(decryptedData.organizationName);
          }
      } catch (error) {
        console.error("Error fetching form validity:", error);
      }
    };

    providerName();
  }, [providerId]);

  return (
    <div className="signUpForms">
            <div className="signupCards">
                <div className=" w-100">
                    <img className="signInlogo" src={logoMain} alt="logo" />
                </div>
                <div className="container">
                    <div className="welcomeforms">
                        <p>Hi {organizationName},</p>

                        <p>Welcome to the Onboarding Questionnaire for the NeuroVisual Medicine Training Program!</p>

                        <p>We've crafted this questionnaire to better understand you and your practice, enabling us to tailor your training week to meet your unique needs.</p>

                        <p>We encourage you to complete this questionnaire as thoroughly as possible. While it's understandable if some questions are challenging to answer, providing detailed information will allow us to customize the training program to suit your specific requirements, ensuring you gain the most benefit as you embark on your journey in NeuroVisual Medicine.</p>

                        <p>Embarking on this learning path represents a significant investment in your clinical and business acumen. Physicians who have participated in our course have consistently transformed their practices, leveraging the insights and skills gained from our program.</p>

                        <p>You might encounter questions about topics you've yet to consider extensively—this is perfectly fine. The questionnaire is also intended to prompt reflection and planning for your future as a NeuroVisual specialist.</p>

                        <p>Should you find some questions irrelevant to your practice, please feel free to skip them.</p>

                        <p>We're excited to collaborate with you and support your journey towards success in NeuroVisual Medicine.</p>

                        <p>Wishing you success,</p>

                        <p>The NVMI Team</p>
                    </div>
                    <div className="text-center">
                        <Button
                        className="btnMain"
                        type="submit"
                        variant="contained"
                        color="success"
                        fullWidth
                        onClick={handleStartSignup}
                        >
                          Get Started
                        </Button>
                    </div>
                </div>
            </div>
        </div>
  );
};

export default WelcomeProvider;
